export default {
  rso: 'RSO',
  account: 'Account',
  rsoSoldTo: 'RSO Sold to',
  nikeSubmissionDate: 'Nike Submission Date',
  latestOverdueConfiguration: 'Latest Overdue Configuration:',
  day: 'Day',
  submitQty: 'Submit Qty',
  actualScanQty: 'Actual Scan Qty',
  overdueQty: 'Overdue Qty',
  printBarcode: 'Print Barcode',
  gledSo: 'Gled SO',
  rsoShipTo: 'RSO Ship to',
  bigGroup: 'Big Group',
  productCode: 'Product Code',
  sku: 'SKU',
  upc: 'UPC',
  epc: 'RFID EPC',
  validationResult: 'Validation Result',
  exceptionReason: 'Exception Reason',
  cartonSequence: 'Carton Sequence',
  giDate: 'GI Date',
  rsoCreationDate: 'RSO Creation Date',
  scanDate: 'Scan Date',
  epcVariance: 'EPC Variance',
  overdueConfiguration: 'Overdue Configuration',
  device: 'Device',
  operator: 'Operator',
  skipRate: 'Skip Rate',
  rejectRate: 'Reject Rate',
  byRso: 'By RSO',
  byProductCode: 'By Product Code',
  byAccount: 'By Account',
  invalidRso: 'Invalid RSO',
  overdue: 'OVERDUE',
  normal: 'NORMAL',
  giOwnerGroup: '1028 Owner Group',
  rsoOwnerGroup: 'RSO Owner Group',
  returnType: 'Return Type',
  unableToValidate: 'UNABLE TO VALIDATE',
  rsoPlaceholder: 'Please scan/input',
  carton: 'Carton Sequence (Optional)',
  cartonPlaceholder: 'Please input',
  epcPlaceholder: 'Please scan',
  unitScanCount: 'Unit Scan Count',
  nextCarton: 'Next Carton',
  nextUnit: 'Next Unit',
  deviceError:
    'Unable to recognize RF device code. Please contact Lst-GC.SCPT.NFC-RFID@Nike.com and upgrade the Application.',
  downloadPdfError1: 'RSO not exist in OAE system',
  downloadPdfError2: 'Unknown System Error',
  readError: 'Too close to the product (<10cm), please adjust and rescan.',
  dateMiss: 'Date Missing in OAE',
  switchTo: 'Switch to',
  qrCode: 'QR Code',
  noLabelProduct: 'No Label Product',
  noHangTag: 'No Hang Tag',
  noResponse: 'No Response',
  invalidQRCodeFormat: 'Invalid QR Code Format',
  noAssociatedEPC: 'This QR code has no associated EPC.',
  illegalQRCode: 'Illegal QR Code.',
  tryAgain: 'Please try again.',
  confirm: 'OK',
  cancel: 'Cancel'
}
